exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cipgroupspage-cssmodule-cipgroupspage-component-3H0-I{border:1px dashed red;border:none}", ""]);

// exports
exports.locals = {
	"cipgroupspage-component": "cipgroupspage-cssmodule-cipgroupspage-component-3H0-I"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/CipGroups/cipgroupspage.cssmodule.scss
// module id = 600
// module chunks = 0